// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"c759640a","346":"a2f7c8b8","350":"9e0f3b2a","453":"a58c0e1e","823":"5bf2187f"}[chunkId] + ".chunk.js";
};